import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
const before = ['Searching for ideas', 'Opening old notes', 'Rebuilding sequences', 'Checking timing', 'Planning transitions', 'Starting from zero'];
const after = ['Open the library', 'Choose a complete class', 'Review the structure', 'Adapt where needed', 'Teach'];
export function TransformationSection() {
  return <section className="w-full bg-cream py-10 sm:py-14 lg:py-20" aria-labelledby="shift-heading" data-id="element-238" data-mp="2nya8rk77lm6n">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-239" data-mp="2j4xwm9jpv7us">
        <div className="mx-auto max-w-2xl text-center" data-id="element-240" data-mp="2e87fdiw6e67s">
          <div className="flex justify-center" data-id="element-241" data-mp="298301w707hj5">
            <SectionLabel data-id="element-242" data-mp="299e13o92eb6k">The shift</SectionLabel>
          </div>
          <h2 id="shift-heading" className="mt-3 font-serif text-[1.4rem] font-semibold uppercase leading-[1.1] text-ink sm:text-4xl" data-id="element-243" data-mp="248qah3oqzwcv">
            From “what am I teaching tomorrow?”
            <span className="block text-forest" data-id="element-244" data-mp="fasuvn391ua2">to ready in minutes.</span>
          </h2>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-2.5 sm:gap-4" data-id="element-245" data-mp="k2ubfl7ga75w">
          <div className="flex h-full flex-col rounded-2xl border border-sandDark bg-ivory/70 p-4 text-center sm:p-6" data-id="element-246" data-mp="5d6ail36laip">
            <h3 className="text-[0.6rem] font-semibold uppercase tracking-label text-muted" data-id="element-247" data-mp="ab7t74wp37tn">
              Before
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-248" data-mp="y23hhs1xzkw5">
              {before.map(item => <li key={item} className="flex flex-col items-center gap-1" data-id="element-249" data-mp="12zlohcwefq1i">
                  <XIcon className="h-3 w-3 shrink-0 text-clay" aria-hidden="true" data-id="element-250" data-mp="p1f4n0oabqku" />
                  <span className="text-[0.8rem] leading-snug text-muted sm:text-[0.9rem]" data-id="element-251" data-mp="t27d3rpc1rg2">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="flex h-full flex-col rounded-2xl border border-forest/20 bg-ivory p-4 text-center shadow-card sm:p-6" data-id="element-252" data-mp="3dt7uk17qweya">
            <h3 className="text-[0.6rem] font-semibold uppercase tracking-label text-forest" data-id="element-253" data-mp="1k8o3lqid99mw">
              With Yoga Teacher System™
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-254" data-mp="1ajwdlnwv8zem">
              {after.map(item => <li key={item} className="flex flex-col items-center gap-1" data-id="element-255" data-mp="1ahtfeglk7zyt">
                  <CheckIcon className="h-3 w-3 shrink-0 text-forest" aria-hidden="true" data-id="element-256" data-mp="15kt8k3gvyt6n" />
                  <span className="text-[0.8rem] font-medium leading-snug text-ink sm:text-[0.9rem]" data-id="element-257" data-mp="11l2ki7iqur5t">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 text-center font-serif text-[1.1rem] font-semibold uppercase leading-tight text-ink sm:text-2xl" data-id="element-258" data-mp="mm8jsi2gvzw6">
          Less time planning.
          <span className="block text-forest" data-id="element-259" data-mp="2ly1h6ft6379f">More time teaching.</span>
        </p>
      </div>
    </section>;
}